<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			hide-default-footer
		>
			<template v-slot:item.impuestos="{ item }">
				<span v-if="item.impuestos.length === 0" class="grey--text">No se aplican impuestos</span>
				<div v-else v-for="(impuesto, i) in item.impuestos" :key="`ipto-lta-${i}`">
					<strong>
						- {{ impuesto.descripción.abreviada }}
						<span style="font-size: 90%">({{ impuesto.requerido ? 'Requerido' : 'Opcional' }})</span>:
					</strong>
					<span v-for="(def, j) in impuesto.alternativas" :key="`ipto-lta-${i}-def-${j}`">
						{{ def.porcentaje }}%
						<span v-if="j+1 < impuesto.alternativas.length">, </span>
					</span>
					<br>
				</div>
			</template>
			<template v-slot:item.acciones="{ item }">
				<v-btn icon @click="abrirDiálogoEdición(item)">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</template>
		</v-data-table>

		<v-dialog
      v-model="diálogo"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Definición de impuestos</v-card-title>

        <v-card-text>

					<p>Una definición de impuestos le permitirá asociar a un producto sus respectivos impuestos. En caso de que el impuesto cambie por ley, podrá cambiarlo fácilmente aquí y de inmediato se ajustará a todos los productos que usen esta definición.</p>

					<v-text-field
						v-model="datos.descripción"
						maxlength="50"
						label="Descripción"
						required
					></v-text-field>

					<p>Seleccione a continuación los impuestos que desea aplicar a esta definición</p>

					<div v-for="(impuesto, i) in datos.impuestos" :key="`ipto-${i}`">
						<v-switch
							v-model="impuesto.seleccionado"
							hide-details
						>
							<template v-slot:label>
								<strong>{{ impuesto.descripción.abreviada }}</strong>: {{ impuesto.descripción.formal }}
							</template>
						</v-switch>
						<div v-if="impuesto.seleccionado" style="padding-left: 50px">
							<v-radio-group v-model="impuesto.requerido" :hide-details="impuesto.alternativas.length === 1">
								<v-radio
									label="Requerido"
									color="indigo"
									:value="true"
								></v-radio>
								<v-radio
									label="Opcional"
									color="indigo"
									:value="false"
								></v-radio>
							</v-radio-group>
							<p v-if="impuesto.alternativas.length > 1">
								Seleccione a continuación las posibles alternativas que tendrá este impuesto. Si selecciona más de una opción el vendedor podrá seleccionar cualquiera de ellas a conveniencia.
							</p>
							<v-checkbox
								v-for="(d, j) in impuesto.alternativas"
								:key="`ipto-def-${j}`"
								v-model="d.seleccionado"
								:label="`${d.porcentaje}%`"
								color="indigo"
								:readonly="impuesto.alternativas.length === 1"
								hide-details
							></v-checkbox>
						</div>
					</div>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
						:disabled="fuente.guardando"
            @click="cerrarDiálogo()"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
						:loading="fuente.guardando"
            @click="guardar"
					>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="abrirDiálogoCreación()"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

	</div>
</template>

<script>
import { definicionesDeImpuestos, impuestosDePaís } from '@/../../cliente_comun/fuentes'
import { notificación } from '@/../../cliente_comun/utilidades'

export default {
	name: 'DefinicionesDeImpuestos',
  data: () => ({
		fuente: definicionesDeImpuestos,
		impuestosDePaís: impuestosDePaís,
		diálogo: false,
		datos: {
			identificador: '',
			descripción: '',
			impuestos: []
		},
		encabezado: [
			{ text: 'Descripción', value: 'descripción', sortable: false },
			{ text: 'Impuestos', value: 'impuestos', sortable: false },
			{ text: '', value: 'acciones', sortable: false },
		]
	}),
	mounted: function() {
		this.fuente.inicializar()
	},
	methods: {
		guardar: function() {
			this.fuente.guardar(this.datos, this.datos.identificador).then( () => {
				this.cerrarDiálogo()
			})
		},
		abrirDiálogoCreación: function() {
			this.limpiar()
			this.diálogo = true
		},
		abrirDiálogoEdición: function(obj) {
			if (!obj.identificador) {
				notificación.error('[7320] Ocurrió un error.')
				return
			}

			this.limpiar()
			this.datos.identificador = obj.identificador
			this.datos.descripción = obj.descripción

			for (let i in this.datos.impuestos) {
				for (let ipto of obj.impuestos) {
					if (ipto.identificador === this.datos.impuestos[i].identificador) {
						this.datos.impuestos[i].seleccionado = true
						this.datos.impuestos[i].requerido = ipto.requerido
						for (let j in this.datos.impuestos[i].alternativas) {
							for (let dfncn of ipto.alternativas) {
								if (dfncn.porcentaje === this.datos.impuestos[i].alternativas[j].porcentaje) {
									this.datos.impuestos[i].alternativas[j].seleccionado = true
									break
								}
							}
						}
						break
					}
				}
			}

			this.diálogo = true
		},
		cerrarDiálogo: function() {
			this.diálogo = false
			this.limpiar()
		},
		limpiar: function() {
			let impuestos = []
			for (let ipto of this.impuestosDePaís.listado) {
				let dts = {
					identificador: ipto.identificador,
					seleccionado: false,
					requerido: true,
					descripción: ipto.descripción,
					alternativas: []
				}

				for (let d of ipto.alternativas) {
					if (d.activo) {
						dts.alternativas.push({ porcentaje: d.porcentaje, seleccionado: false })
					}
				}

				if (dts.alternativas.length === 1) {
					dts.alternativas[0].seleccionado = true
				}

				impuestos.push(JSON.parse(JSON.stringify(dts)))
			}

			this.datos.identificador = ''
			this.datos.descripción = ''
			this.datos.impuestos = impuestos
		}
	}
}
</script>